var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSkipStep = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20ZM9.42426 14.4243L13.4243 10.4243C13.6586 10.1899 13.6586 9.81005 13.4243 9.57574L9.42426 5.57574C9.18995 5.34142 8.81005 5.34142 8.57574 5.57574C8.34142 5.81005 8.34142 6.18995 8.57574 6.42426L12.1515 10L8.57574 13.5757C8.34142 13.8101 8.34142 14.1899 8.57574 14.4243C8.81005 14.6586 9.18995 14.6586 9.42426 14.4243Z",
  fill: "currentColor"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgSkipStep);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "assets/skipStep.3208c97140994785c294bf775a6cede7.svg";